module.exports = __webpack_public_path__ + "img/hand.18960251.svg";